function Jobname(title="") {

    this.name = 'jobname';
    this.title = title;
}

export {Jobname};
